// Parallax on scroll: translates element along an axis based on its
// position in the viewport. Uses requestAnimationFrame and cleans up.
export default function parallax(node, opts = {}) {
  const {
    speed = 0.25, // fraction of viewport influence
    axis = 'y',   // 'y' or 'x'
    max = 40,     // px clamp
    initial = 0   // base offset in px
  } = opts;

  let raf;
  const onScroll = () => {
    if (raf) cancelAnimationFrame(raf);
    raf = requestAnimationFrame(update);
  };

  function update() {
    const rect = node.getBoundingClientRect();
    const vh = window.innerHeight || 1;
    const centerDelta = (vh / 2) - (rect.top + rect.height / 2);
    const amt = Math.max(Math.min(centerDelta * speed, max), -max) + initial;
    const t = axis === 'x' ? `translateX(${amt}px)` : `translateY(${amt}px)`;
    node.style.transform = t;
    node.style.willChange = 'transform';
  }

  update();
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  return {
    destroy() {
      cancelAnimationFrame(raf);
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
    }
  };
}

